export interface INotificationType {
  id: number;
  targetType: string;
  name: string;
  description: string;
}
